var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "giftcertificates-plugin" },
    [
      _c("certificate-form", {
        attrs: { settings: _vm.settings, selector: _vm.selector },
        on: { saved: _vm.onSaved }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }